import { useRef, useEffect, useState } from "react"
import "./case-study-problem-solution.component.css"

const CaseStudyProblemSolutionComponent = (props) => {
  const { ProblemSolutions, HexColor } = props
  const [isVisible, setIsVisible] = useState(false)
  const ref = useRef(null)

  useEffect(() => {
    const el = ref.current
    if (!el) return

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true)
          observer.unobserve(el)
        }
      },
      { threshold: 0.3 },
    )

    observer.observe(el)
    return () => observer.disconnect()
  }, [])

  return (
    <div
      ref={ref}
      className={`dagger-case-study-solutions ${isVisible ? "dagger-slide-in-visible" : "dagger-slide-in-hidden"}`}
    >
      {ProblemSolutions?.map((p) => {
        return (
          <div className="dagger-case-study-solution" key={p.id}>
            <h5 style={{ color: HexColor }}>{p.Heading}</h5>
            <p>{p.Copy}</p>
          </div>
        )
      })}
    </div>
  )
}

export default CaseStudyProblemSolutionComponent
